import { FC } from 'react';
import { Tabs } from 'antd';
import { usePermission } from 'hooks';

import { PageWrapper } from 'components/ui';
import { Prompts, Requests } from './components';

const IS_PROMPTS_ENABLED = false;

const AiHealth: FC = () => {
  const { isSuperAdmin } = usePermission();

  return (
    <PageWrapper title="Ai Assistant" color="white">
      {isSuperAdmin && IS_PROMPTS_ENABLED ? (
        <Tabs
          items={[
            {
              key: 'requests',
              label: 'Requests',
              children: <Requests />
            },
            {
              key: 'prompts',
              label: 'Prompts',
              children: <Prompts />
            }
          ]}
        />
      ) : (
        <Requests />
      )}
    </PageWrapper>
  );
};

export default AiHealth;
